import React from 'react';
import { FrontIframeOverlay, type FrontOverlayMode } from '../../../ips-react-front-fw/components/overlay';

type Props = {
  open: boolean;
  mode: FrontOverlayMode;
  loading: boolean;
  iframeSrc: string;
  openPageHref: string;
  onClose: () => void;
  onIframeLoad: () => void;
};

export const MembershipOverlay: React.FC<Props> = ({
  open,
  mode,
  loading,
  iframeSrc,
  openPageHref,
  onClose,
  onIframeLoad,
}) => {
  return (
    <FrontIframeOverlay
      open={open}
      onClose={onClose}
      mode={mode}
      src={iframeSrc}
      title="Membership"
      loading={loading}
      onLoad={onIframeLoad}
      panelClassName="ips-front-membership-overlay-panel"
      wrapperClassName="ips-front-membership-overlay"
      iframeTitle="Membership"
      closeLabel="Close"
      openPageHref={openPageHref}
      openPageLabel="Vollseite öffnen"
    />
  );
};
